<template>
    <v-container container--fluid>
        <v-layout align-center justify-center>
            <v-flex xs12 sm12 md10>
                <v-card class="elevation-12">
                    <v-toolbar flat dark color="primary">
                        <v-toolbar-title>Reset Password</v-toolbar-title>
                    </v-toolbar>
                    <v-card-text>
                        <v-alert v-model.trim="alert" outlined transition="scale-transition" dismissible type="error">{{ authErrors.get("invalid_username") }}</v-alert>
                        <v-alert v-model.trim="alert2" outlined transition="scale-transition" dismissible type="success">Password Reset Successfully</v-alert>
                        <v-form class="overwrite-inputs" ref="resetform" v-model.trim="valid" lazy-validation>
                            <v-flex xs12 sm12 md12>
                                <v-text-field
                                    placeholder="Username"
                                    prepend-icon="person"
                                    v-model.trim="username"
                                    :rules="usernameRules"
                                    :error="authErrors.has('username')"
                                    :error-messages="authErrors.get('username')"
                                    required
                                ></v-text-field>
                            </v-flex>
                            <v-flex xs12 sm12 md12>
                                <v-text-field
                                    prepend-icon="lock"
                                    v-model.trim="password"
                                    :append-icon="showpwd ? 'visibility_off' : 'visibility'"
                                    :type="showpwd ? 'text' : 'password'"
                                    name="password"
                                    :rules="passwordRules"
                                    :error="authErrors.has('password')"
                                    :error-messages="authErrors.get('password')"
                                    placeholder="Password"
                                    @click:append="showpwd = !showpwd"
                                    required
                                ></v-text-field>
                            </v-flex>
                            <v-flex xs12 sm12 md12>
                                <v-text-field
                                    prepend-icon="lock"
                                    v-model.trim="password_confirmation"
                                    :append-icon="showpwdConfirmation ? 'visibility_off' : 'visibility'"
                                    :type="showpwdConfirmation ? 'text' : 'password'"
                                    name="password_confirmation"
                                    :rules="passwordConfirmationRules"
                                    :error="authErrors.has('password')"
                                    placeholder="Password Confirnation"
                                    @click:append="showpwdConfirmation = !showpwdConfirmation"
                                    required
                                ></v-text-field>
                            </v-flex>
                        </v-form>
                    </v-card-text>
                    <v-card-actions class="pb-4">
                        <v-btn @click="clear" color="warning" :disabled="loginLoading" class="text-left">clear<v-icon right>clear</v-icon></v-btn>
                        <v-btn :loading="loginLoading" :disabled="!valid" color="primary" @click="resetPassword" class="text-left">Reset Password<v-icon right>send</v-icon></v-btn>
                    </v-card-actions>
                    <v-divider light></v-divider>
                    <v-card-text>
                        <div class="text-center pt-2"><span color="gray--text">Already have an account?</span> <router-link :to="{ name: 'login' }">Login</router-link></div>
                    </v-card-text>
                </v-card>
            </v-flex>
        </v-layout>
    </v-container>
</template>

<script>
export default {
    data() {
        return {
            action: "password-reset",
            username: "",
            usernameRules: [v => !!v || "Username is required"],
            password: "",
            passwordRules: [v => !!v || "Password is required"],
            password_confirmation: "",
            passwordConfirmationRules: [v => !!v || "Password Confirmation is required"],
            token: "",
            showpwd: false,
            showpwdConfirmation: false,
            valid: true,
            alert: false,
            alert2: false,
        };
    },
    computed: {
        authErrors() {
            return this.$store.getters["auth/authErrors"];
        },
        loginLoading() {
            return this.$store.getters["auth/authStatus"] == "loading";
        },
    },
    methods: {
        clear() {
            this.alert = false;
            this.alert2 = false;
            this.$refs.resetform.reset();
            this.$store.dispatch("auth/clearErrors");
        },
        resetPassword: function() {
            if (this.$refs.resetform.validate()) {
                this.valid = false;
                let token = this.token;
                const { action, username, password, password_confirmation } = this;
                this.$store
                    .dispatch("auth/resetPwdEmail", { action, username, password, password_confirmation, token })
                    .then(resp => {
                        // console.log(resp);
                        this.alert2 = true;
                        var _self = this;

                        setTimeout(function() {
                            _self.$router.push({ name: "dashboard" });
                        }, 2000);
                    })
                    .catch(err => {
                        this.valid = true;
                        // console.log(err);

                        if (this.authErrors.has("invalid_username")) {
                            this.alert = true;
                            var _self = this;
                            setTimeout(function() {
                                _self.alert = false;
                            }, 2000);
                        }
                    });
            }
        },
    },
    mounted() {
        let token = this.$route.params.token;
        if (!token) {
            this.$router.push({ name: "home" });
        }
        this.token = token;
    },
};
</script>
